import { HttpError } from '../../config/Axios/axios-instance';
import * as actionTypes from './actionTypes';
import { SubscriptionActionTypes } from './actionTypes';
import { Subscription } from '../../domain/Subscription';

export interface SubscriptionStateType {
  publicSubscriptions: Subscription[] | null;
  publicSubscriptionsLoading: boolean;
  publicSubscriptionsError: HttpError | null;
}

export type SubsciptionActionType = SubscriptionStateType & {
  type: SubscriptionActionTypes;
};

export const initialState: SubscriptionStateType = {
  publicSubscriptions: null,
  publicSubscriptionsLoading: false,
  publicSubscriptionsError: null,
};

const fetchPublicSubscriptionsStart = (
  state: SubscriptionStateType,
): SubscriptionStateType => ({
  ...state,
  publicSubscriptions: null,
  publicSubscriptionsLoading: true,
  publicSubscriptionsError: null,
});

const fetchPublicSubscriptionsSuccess = (
  state: SubscriptionStateType,
  action: SubsciptionActionType,
): SubscriptionStateType => ({
  ...state,
  publicSubscriptions: action.publicSubscriptions,
  publicSubscriptionsLoading: false,
  publicSubscriptionsError: null,
});

const fetchPublicSubscriptionsFail = (
  state: SubscriptionStateType,
  action: SubsciptionActionType,
): SubscriptionStateType => ({
  ...state,
  publicSubscriptions: null,
  publicSubscriptionsLoading: false,
  publicSubscriptionsError: action.publicSubscriptionsError,
});

const resetSubscriptionStore = (): SubscriptionStateType => ({
  ...initialState,
});

const reducer = (state = initialState, action: SubsciptionActionType) => {
  switch (action.type) {
    case actionTypes.FETCH_PUBLIC_SUBSCRIPTIONS_START:
      return fetchPublicSubscriptionsStart(state);
    case actionTypes.FETCH_PUBLIC_SUBSCRIPTIONS_SUCCESS:
      return fetchPublicSubscriptionsSuccess(state, action);
    case actionTypes.FETCH_PUBLIC_SUBSCRIPTIONS_FAIL:
      return fetchPublicSubscriptionsFail(state, action);
    case actionTypes.RESET_SUBSCRIPTION_STORE:
      return resetSubscriptionStore();
    default:
      return state;
  }
};

export default reducer;
